import { IParamsGetUnit } from 'app/api/hr/model'
import { ParamsList } from 'parkway-web-common'

export const WarehouseUnitKeys = {
  allAreas: ['Areas'] as const,
  warehouseUnits: () => [...WarehouseUnitKeys.allAreas, 'warehouseUnits'] as const,
  getWarehouseUnits: (filters?: ParamsList & IParamsGetUnit) =>
    [...WarehouseUnitKeys.warehouseUnits(), { filters }] as const,
}
